// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BoundedMessagePreview_preview__aZYDZ {
  border-left: 2px solid #4778EE;
  padding: 4px 4px 0;
  flex-grow: 1;
  min-width: 1px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.BoundedMessagePreview_title__Gdaqe {
  color: #4778EE;
  font-size: 12px;
  font-weight: 500;
  min-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BoundedMessagePreview_messageContent__8GCz9 {
  color: #272A36;
  max-width: 100%;
  font-size: 12px;
  font-weight: 400;
  margin-top: 2px;
  min-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/BoundedMessagePreview/BoundedMessagePreview.module.scss","webpack://./../../packages/sdk/src/assets/mixins.scss"],"names":[],"mappings":"AAEA;EACE,8BAAA;EAEA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAFF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EAEA,cAAA;EClBA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADcF;;AAMA;EACE,cAAA;EACA,eAAA;EAEA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EC7BA,mBAAA;EACA,gBAAA;EACA,uBAAA;AD0BF","sourcesContent":["@import '@roolz/sdk/assets/mixins.scss';\n\n.preview {\n  border-left: 2px solid #4778EE;\n\n  padding: 4px 4px 0;\n  flex-grow: 1;\n  min-width: 1px;\n  cursor: pointer;\n  user-select: none;\n\n  //@include ellipsis;\n}\n\n.title {\n  color: #4778EE;\n  font-size: 12px;\n  font-weight: 500;\n\n  min-width: 1px;\n  @include ellipsis;\n}\n\n.messageContent {\n  color: #272A36;\n  max-width: 100%;\n\n  font-size: 12px;\n  font-weight: 400;\n  margin-top: 2px;\n  min-width: 1px;\n\n  @include ellipsis;\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin applyToChildrenExceptLast($property, $value) {\n  & > *:not(:last-child) {\n    #{$property}: #{$value}\n  }\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `BoundedMessagePreview_preview__aZYDZ`,
	"title": `BoundedMessagePreview_title__Gdaqe`,
	"messageContent": `BoundedMessagePreview_messageContent__8GCz9`
};
export default ___CSS_LOADER_EXPORT___;
